/* Steamero — comportements d'interface partagés.
   Tout est optionnel : si ce script ne se charge pas, le site reste
   entièrement lisible et utilisable. */

(function () {
  'use strict';

  /* ---- Apparition au défilement ------------------------------------- */

  function watchReveals(root) {
    var targets = (root || document).querySelectorAll('.st-reveal:not(.is-watched)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in', 'is-watched'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) {
      el.classList.add('is-watched');
      io.observe(el);
    });
  }

  /* ---- Accordéon FAQ -------------------------------------------------
     <details> natif : accessible et fonctionnel sans JS. On n'ajoute ici
     que la fermeture des autres panneaux du même groupe.               */

  function wireAccordions(root) {
    var groups = (root || document).querySelectorAll('[data-st-accordion]:not(.is-wired)');
    groups.forEach(function (group) {
      group.classList.add('is-wired');
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function init(root) {
    watchReveals(root);
    wireAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Rechargement d'une section depuis l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
